"use strict";

exports.__esModule = true;
exports["default"] = createGetFormNames;

function createGetFormNames(_ref) {
  var getIn = _ref.getIn,
      keys = _ref.keys;
  return function (getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };

      return keys(nonNullGetFormState(state));
    };
  };
}


//////////////////
// WEBPACK FOOTER
// ./~/redux-form/lib/selectors/getFormNames.js
// module id = 2097
// module chunks = 0